import { useEffect, useState } from "react";
import api from "../api";

// Small public config (prices, category state, flags). One fetch, cached across the app.
let cache = null;
let inflight = null;

export const loadConfig = () => {
  if (cache) return Promise.resolve(cache);
  if (!inflight) {
    inflight = api.get("/config").then((r) => { cache = r.data || {}; return cache; }).catch(() => ({}));
  }
  return inflight;
};

export const useConfig = () => {
  const [cfg, setCfg] = useState(cache);
  useEffect(() => { loadConfig().then(setCfg); }, []);
  return cfg; // null until the first fetch resolves
};
